/* eslint-disable import/prefer-default-export */
export function clEvents(state) {
  return state.clEvents;
}



// WEBPACK FOOTER //
// ./src/app/cl-events/store/getters.js